import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useLoginContext } from "../../Contexts/LoginContext";
import NumberField from "../../Components/NumberField";
import ErrorModal from "../../Components/ErrorModal";
import LoginModal from "../../Components/LoginModal";
import { CircularProgress } from "@mui/material";
import Button from "../../Components/Button";
import { useState } from "react";

function Login() {
  const [showModal, setShowModal] = useState(false);
  const {
    formatMobileNumber,
    setDisplayAlert,
    setAlertMessage,
    setAlertTitle,
    displayAlert,
    mobileNumber,
    alertMessage,
    alertTitle,
    handleNext,
    handleBack,
    isLoading,
  } = useLoginContext();

  const handleClose = () => {
    setDisplayAlert(false);
    setAlertTitle("");
    setAlertMessage("");
  };

  const handleShow = () => setShowModal(true);

  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" || event.key === " ") {
      callback();
    }
  };

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center cursor-default">
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl sm:mt-24 ">
        <div className="w-full grid grid-cols-1 divide-y">
          <div className="flex flex-row p-3">
            <KeyboardArrowLeftIcon
              className="cursor-pointer"
              onClick={handleBack}
            />
            <div className="text-center text-md font-bold flex-grow">Login</div>
          </div>

          <div className="p-4">
            <div className="text-[#1F2328] text-2xl font-bold">
              Welcome back!
            </div>
            <div className="text-[#60656D] mb-2">
              Enter your mobile number to access your account
            </div>
            <form onSubmit={handleNext}>
              <div>
                <div className="text-[#1F2328] font-bold">Mobile number</div>
                <div className="mt-2">
                  <NumberField
                    disabled={
                      alertMessage ===
                      "Login initialization was unsuccessful. Please refresh the page."
                    }
                    name="mobileNumber"
                    value={mobileNumber}
                    adornment="+63"
                    onChange={formatMobileNumber}
                    error={!displayAlert && alertMessage}
                    helperText={!displayAlert ? alertMessage : ""}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="bg-white flex-grow" />
        <div className="flex flex-col sm:items-end items-center w-full px-4">
          <Button
            disabled={isLoading}
            className={`h-12 w-full transition ease-in-out delay-75 rounded-xl text-white
							${isLoading ? "bg-[#F6F7F7]" : "bg-[#0947AB]"}`}
            onClick={handleNext}
          >
            {isLoading ? <CircularProgress size={"1rem"} /> : "Continue"}
          </Button>
        </div>
    
        <div className="w-full text-center mt-2 mb-3">
          <p className="text-[#60656D] font-semibold">
            Haven't activated your Member Gateway Account yet? {/* */}
            <button
              className="text-[#0947AB] font-bold cursor-pointer"
              onClick={handleShow}
              onKeyDown={(event) => handleKeyDown(event, () => handleShow)}
            >
              {" "}
              Activate Now
            </button>
          </p>
        </div>
        <LoginModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          message={"Unlock wellness: Activate your Member Gateway Account!"}
          body={
            "Exciting news! Register your Maxicare card today and unlock exclusive benefits. Plus, enjoy the convenience of your new account, all in one go! Ready to experience wellness at your fingertips? Let's get started!"
          }
        />
      </div>
      <ErrorModal
        open={displayAlert}
        title={alertTitle}
        message={alertMessage}
        onClose={handleClose}
      />
    </div>
  );
}

export default Login;
